module.exports = __webpack_public_path__ + "img/home-header-img.53f4fbd8.png";